import { config } from '../config';

type MockModeInputs = {
  isProduction: boolean;
  isStaging: boolean;
  envUseMock: boolean;
  queryMock: string | null;
};

/** Pure resolver for unit tests and {@link isMockMedplumMode}. */
export function resolveMockMedplumMode(inputs: MockModeInputs): boolean {
  if (inputs.queryMock === 'true' && !inputs.isProduction && !inputs.isStaging) {
    return true;
  }
  if (inputs.queryMock === 'false') {
    return false;
  }
  if (inputs.isProduction || inputs.isStaging) {
    return false;
  }
  return inputs.envUseMock;
}

/**
 * Whether the SPA should use mock Medplum-style behavior for local demos.
 * Matches the intent of {@link useAppointmentsData} (query `?mock=false`, env
 * `VITE_USE_MOCK_MEDPLUM=false`, and never mock in staging/production profiles).
 *
 * `?mock=true` opts in for local/e2e runs even when `VITE_USE_MOCK_MEDPLUM=false`
 * (CI docker-compose sets that explicitly).
 */
export function isMockMedplumMode(): boolean {
  const queryMock =
    typeof window !== 'undefined'
      ? new URLSearchParams(window.location.search).get('mock')
      : null;
  return resolveMockMedplumMode({
    isProduction: config.isProduction,
    isStaging: config.isStaging,
    envUseMock: import.meta.env.VITE_USE_MOCK_MEDPLUM !== 'false',
    queryMock,
  });
}
